<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let data = [
    { name: '高标准农田', value: 133.44 },
    { name: '2025年之前再建', value: 30.06 },
  ]
  const colors = ['#35F1A4', '#FEC74C']
  var legendTextStyle = function (idx) {
    return {
      fontSize: 24,
      padding: [0, 5, 0, 5],
      color: colors[idx], // 使用颜色数组中的颜色
    };
  };
  const chartData = data.map((item, index) => ({
    value: item.value,
    name: item.name,
    itemStyle: {
      shadowBlur: 20,
      shadowColor: `#${(((index + 1) % 7) + 10) * 100 + 99}`,
      shadowOffsetx: 25,
      shadowOffsety: 20,
      color: colors[index % colors.length],
    },
  }))
  const sum = chartData.reduce((per, cur) => per + cur.value, 0)
  const gap = (1 * sum) / 100
  const pieData1 = []
  const gapData = {
    name: '',
    value: gap,
    itemStyle: {
      color: 'transparent',
    },
  }

  for (let i = 0; i < chartData.length; i++) {
    // 第一圈数据
    pieData1.push({
      ...chartData[i],
    })
    pieData1.push(gapData)
  }
  const option= {
    title: {
        show: true,
        subtext: '',
        x: '19%',
        y: '29%',
      text: ' {a|}',
      textStyle: {
        rich: {
          a: {
            color: '#FFF',//设置 动态数据字体的颜色
            fontSize: '30',//设置 动态数据字体的大小
            height: 112,
            width: 112,
            backgroundColor: {
              image: 'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nongye1(1)/nt.png'
            }
          },
        }
      }
    },
    legend: {
      orient: 'vertical',
      icon: '',
      top: '30%',
      right: '5%',
      itemGap: 50,
      itemHeight: 30,
      itemWidth: 30,
      data: chartData,
      formatter: function (name) {
        console.log(name)
        const selectedItem = chartData.find((item) => `${item.name}`.includes(`${name}`));
        if (selectedItem) {
          const { value } = selectedItem;
          const p = ((value / sum) * 100).toFixed(2);
          const area = `${value}万亩`;
          // return `${name}    ${<span style="color:colors[0]">area</span>}`;
          if(name=="高标准农田"){
            return "{name|" + name + "：}" + "{value|" +area + "}";
          }
          if(name=="2025年之前再建"){
            return "{name|" + name + "：}" + "{value1|" +area + "}";
          }

          // ${p}%
        } else {
          return name;
        }
      },
      textStyle: {
        color:"auto",
        fontSize:30,
        rich: {
          name: {
            // width: '45%',
            fontSize: 40,
            color: "#fff",
            padding:[8,0,0,16],
          },
          value: {
            // width: '45%',
            fontSize: 40,
            color: "#35F1A4",
            padding:[8,0,0,0],
          },
          value1: {
            // width: '45%',
            fontSize: 40,
            color: "#FEC74C",
            padding:[8,0,0,0],
          },
        },
      },
    },
    series: [
      // 中间圆环
      {
        name: '',
        type: 'pie',
        roundCap: true,
        radius: ['45%', '52%'],
        center: ['25%', '40%'],
        data: pieData1,
        labelLine: {
          length: 8,
          length2: 16,
          lineStyle: {
            width: 1,
          },
        },
        label: {
          show: false,
          fontFamily: 'ysbth',
          position: 'outside',
          padding: [0, -4, 0, -4],
          formatter(params) {
            if (params.name === '') {
              return ''
            }
            return `${params.percent.toFixed(0)}%`
          },
          color: '#fff',
          fontSize: '14px',
          lineHeight: 10,
        },
        emphasis: {
          // 鼠标移入时显示
          label: {
            show: true,
          },
        },
      }
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
